import { Controller } from "react-hook-form";

import { Checkbox, FormControlLabel, FormGroup } from "@/components/ui-v2";

import { EXPORT_FORM_FIELDS } from "../../../constants";

export const ExportFormSaveSelections = () => (
  <FormGroup>
    <Controller
      name={EXPORT_FORM_FIELDS.SAVE_SELECTIONS}
      render={({ field }) => (
        <FormControlLabel
          control={<Checkbox {...field} checked={field.value} size="small" />}
          label="Save my preferences"
        />
      )}
    />
  </FormGroup>
);
